import { Routes } from '@angular/router';
import { Permissions } from '../../../Models/Permissions';
import { AirswebComponent } from './airsweb.component';
import { NewAirswebComponent } from './airsweb.new.component';
import { CloneTenantComponent } from './CloneTenant/clone-tenant.component';
import { TenantCopyConfigComponent } from './CopyConfig/tenant.copyconfig.component';
import { TenantDeleteComponent } from './Delete/tenant.delete.component';
import { FeatureGuard } from './feature.guard';
import { FeatureFlagsComponent } from './FeatureFlags/FeatureFlag/feature-flag.component';
import { FeedConfigurationDetailComponent } from './Feeds/feed-configuration-detail/feed-configuration-detail.component';
import { FeedConfigurationSummaryComponent } from './Feeds/feed-configuration-summary/feed-configuration-summary.component';
import { HierarchyImportComponent } from './Imports/hierarchy-import/hierarchy-import.component';
import { HistoricalDataImportComponent } from './Imports/historical-data-import/historical-data-import.component';
import { ImportComponent } from './Imports/import.component';
import { NewImportComponent } from './Imports/new.import.component';
import { LanguagesComponent } from './Languages/languages.component';
import { ListsComponent } from './Lists/lists.component';
import { LocationAttributesComponent } from './LocationAttributes/location-attributes.component';
import { MaintenanceTasksComponent } from './maintenance-tasks/maintenance-tasks.component';
import { MatrixComponent } from './matrix';
import { MatrixPickerComponent } from './matrix/matrix/matrix-picker.component';
import { OverviewComponent } from './Overview/overview.component';
import { PackageComponent } from './Package/package.component';
import { PermissionsComponent } from './Permissions/permissions.component';
import { PurgeDataComponent } from './purge-data/purge-data.component';
import { ReleaseComponent } from './Release/release.component';
import { CopyConfigLogsComponent } from './CopyConfigLogs/copy-config-logs.component';
import { AwDiffComponent } from '@app/Tenant/Applications/Airsweb/Module/aw-diff/aw-diff.component';
import { AW_MODULE_ROUTES } from './Module/aw-module.routes';

export const AIRSWEB_ROUTES: Routes = [
	{
		path: 'airsweb',
		component: AirswebComponent,
		children: [
			{ path: '', redirectTo: 'overview', pathMatch: 'full' },
			{
				path: 'modules',
				children: AW_MODULE_ROUTES
			},
			{ path: 'packages', component: PackageComponent },
			{ path: 'packages-from-create-package', component: PackageComponent },
			{ path: 'releases', component: ReleaseComponent },
			{ path: 'comparechanges', component: AwDiffComponent },
			{ path: 'releases/:releaseNumber', component: ReleaseComponent },
			{ path: 'overview', component: OverviewComponent },
			{
				path: 'imports',
				component: ImportComponent,
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.imports] }
			},
			{
				path: 'imports/new/historicaldata',
				component: HistoricalDataImportComponent,
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.imports] }
			},
			{
				path: 'imports/new/hierarchy',
				component: HierarchyImportComponent,
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.imports] }
			},
			{
				path: 'imports/new/:type',
				component: NewImportComponent,
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.imports] }
			},
			{ path: 'lists', component: ListsComponent },
			{ path: 'new', component: NewAirswebComponent },
			{ path: 'delete', component: TenantDeleteComponent },
			{
				path: 'feeds',
				component: FeedConfigurationSummaryComponent, pathMatch: 'full',
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.feeds] }
			},
			{
				path: 'feeds/new',
				component: FeedConfigurationDetailComponent,
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.feeds] }
			},
			{
				path: 'feeds/:id',
				component: FeedConfigurationDetailComponent,
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.feeds] }
			},
			{ path: 'languages', component: LanguagesComponent },
			{
				path: 'permissions',
				component: PermissionsComponent,
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.access] }
			},
			{
				path: 'copyconfig',
				component: TenantCopyConfigComponent,
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.copyConfig] }
			},
			{ path: 'copyconfig/logs', component: CopyConfigLogsComponent },
			{
				path: 'clone',
				component: CloneTenantComponent,
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.cloneTenant] }
			},
			{ path: 'hierarchy-attributes', component: LocationAttributesComponent },
			{ path: 'matrix', component: MatrixPickerComponent },
			{ path: 'matrix/:name', component: MatrixComponent },
			{ path: 'matrix/:name/copy', component: MatrixComponent },
			{ path: 'feature-flags', component: FeatureFlagsComponent },
			{
				path: 'maintenance',
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.maintenance] },
				children: [{
					path: '',
					component: MaintenanceTasksComponent
				}]
			},
			{
				path: 'purge-data',
				canActivate: [FeatureGuard],
				data: { permissionsRequired: [Permissions.removeData] },
				children: [{
					path: '',
					component: PurgeDataComponent
				}]
			}
		]
	}
];
